import React, { Component } from "react";
import { Link } from "react-router-dom";

import { SOCIALS, FOOTER_LINKS } from "../../constants";
import ScrollTop from "./ScrollTop";

class Footer extends Component {
  static renderSocials() {
    return SOCIALS.map(({ title, icon, url }) => {
      return (
        <a
          key={url}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-connect-link"
        >
          <i className={icon}></i>
          <span>{title}</span>
        </a>
      );
    });
  }

  renderNavLinks() {
    return FOOTER_LINKS[0].set.map(({ path, text }) => {
      return (
        <li key={`FOOTER_${text}`}>
          <Link to={path}>{text}</Link>
        </li>
      );
    });
  }

  render() {
    return [
      <ScrollTop key="scroll-top" />,
      <footer
        key="footer"
        id="main-footer"
        className="page-footer elegant-color-dark center-on-small-only"
      >
        <div className="container">
          <div className="row footer-cta-row">
            <div className="col text-center">
              <h5 className="footer-cta-heading anim_piece">
                Have an idea worth building?
              </h5>
              <p className="footer-cta-sub anim_piece">
                I'm always interested in SaaS, AI, product, and technical
                collaboration.
              </p>
              <Link
                to="/contact"
                className="btn btn-dark-green waves-effect anim_piece"
              >
                Get in Touch
              </Link>
            </div>
          </div>

          <div className="row footer-columns">
            <div className="col-12 col-md-4 footer-col anim_piece">
              <Link to="/">
                <img id="branding" src="/img/logo.png" alt="Fernan de Dios" />
              </Link>
              <p className="footer-tagline">
                Technical lead, consultant and SaaS founder
              </p>
              <p className="footer-supporting">
                Building useful software, SaaS products, and AI-powered
                experiences.
              </p>
            </div>

            <div className="col-12 col-md-4 footer-col anim_piece">
              <h5 className="footer-col-title">Navigate</h5>
              <ul className="list-unstyled footer-nav-list">
                {this.renderNavLinks()}
              </ul>
            </div>

            <div className="col-12 col-md-4 footer-col anim_piece">
              <h5 className="footer-col-title">Connect</h5>
              <div className="footer-connect-list">
                {Footer.renderSocials()}
                <a
                  href="mailto:fernandedios@gmail.com"
                  className="footer-connect-link"
                >
                  <i className="fa fa-envelope-o"></i>
                  <span>Email</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <div className="container footer-bottom-row">
            <div className="footer-bottom-text">
              <span>&copy; 2026 Fernan de Dios</span>
              <span className="footer-bottom-sep">&middot;</span>
              <span>Built with curiosity, persistence, and iteration.</span>
            </div>
            <Link to="/privacy" className="footer-bottom-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>,
    ];
  }
}

export default Footer;
